import { type LucideIcon } from 'lucide-react'
import { cn } from '@/utils/helpers'

type MeetingActionButtonProps = {
  icon: LucideIcon
  onClick: () => void
  variant?: 'default' | 'destructive'
  disabled?: boolean
  className?: string
  buttonSize?: 'md' | 'lg'
}

export const MeetingActionButton = ({
  icon: Icon,
  onClick,
  variant = 'default',
  disabled = false,
  className,
  buttonSize = 'md'
}: MeetingActionButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'flex items-center justify-center',
        'w-12 h-12',
        'rounded-full',
        'transition-colors duration-200',
        'focus:ring-2 focus:ring-brand-primary focus:ring-offset-0',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        buttonSize === 'md' ? 'w-[54px] h-[54px]' : 'w-16 h-16',
        variant === 'destructive'
          ? 'bg-red-500 text-white hover:bg-red-600'
          : 'bg-[#5B5B5B] text-white hover:bg-[#5B5B5BAA]',
        className
      )}
      aria-label={variant === 'destructive' ? 'Leave meeting' : 'Action'}
    >
      <Icon className="h-5 w-5 shrink-0" />
    </button>
  )
}
